import React from 'react';
import HomeInquiryButton from '../../../assets/images/home_inquiry.svg';
import SunlightIcon from '../../../assets/images/sunlight.svg';
import { Link } from 'react-router-dom';
import { useInView } from "react-intersection-observer";

// 예전에는 오른쪽 3/5에 CMS 배너 슬라이더가 있었으나, 그 API(/docs/banners)가
// 500을 내려 슬라이드가 한 장도 뜨지 않은 채 빈 파란 공간만 남아 있었다.
// 슬라이더와 죽은 호출을 걷어내고, 캠퍼스소식 히어로와 같은 가운데 정렬로 맞췄다.

const BannerSection = () => {
    const { ref: sectionRef, inView } = useInView({
        threshold: 0.5,
        triggerOnce: false,
    });

    return (
        <section ref={sectionRef} className="relative overflow-hidden">
            {/* 배경 뒤에 떠다니는 원형 꾸밈 요소 */}
            <div className="absolute top-[10%] left-[5%] w-[300px] h-[300px] rounded-full bg-primary/15 backdrop-blur-md animate-float z-0"></div>
            <div className="absolute bottom-[15%] right-[10%] w-[200px] h-[200px] rounded-full bg-primary/20 backdrop-blur-sm animate-floatDelay z-0"></div>
            <div className="absolute top-[40%] right-[20%] w-[150px] h-[150px] rounded-full bg-primary/10 backdrop-blur-sm animate-floatSlow z-0"></div>
            <div className="absolute bottom-[30%] left-[15%] w-[100px] h-[100px] rounded-full bg-primary/15 backdrop-blur-md animate-floatReverse z-0"></div>
            <div className="absolute top-[60%] right-[5%] w-[250px] h-[250px] rounded-full bg-primary/10 backdrop-blur-md animate-floatReverse z-0"></div>
            <div className="absolute bottom-[50%] left-[40%] w-[100px] h-[100px] rounded-full bg-primary/15 backdrop-blur-sm animate-float z-0"></div>
            <div className="absolute top-[75%] left-[30%] w-[160px] h-[160px] rounded-full bg-primary/8 backdrop-blur-sm animate-floatDelay z-0"></div>
            <div className="absolute top-[15%] right-[35%] w-[220px] h-[220px] rounded-full bg-primary/10 backdrop-blur-md animate-floatSlow z-0"></div>
            <div className="absolute bottom-[10%] left-[60%] w-[130px] h-[130px] rounded-full bg-primary/15 backdrop-blur-sm animate-floatReverse z-0"></div>

            <div className="relative z-10 w-full bg-primary/80 px-[20px] tablet:px-[35px] desktop:px-[50px] pt-[40px] pb-[36px] desktop:pt-[72px] desktop:pb-[64px]">
                <div className="max-w-[1480px] mx-auto flex flex-col items-center text-center">
                    <div className="flex justify-center items-start gap-3">
                        <div className={`text-white tablet:text-display-medium text-headline-medium font-semibold font-inter tablet:leading-[58px] leading-[38px] break-keep ${inView ? 'animate-fadeSlideUp' : ''}`}>
                            Enjoy the Journey of<br /> Learning English!
                        </div>
                        <img src={SunlightIcon} alt="Sunlight Icon" className="w-[55px] h-[55px] translate-y-[-10px]" />
                    </div>

                    <div className={`text-white mt-[14px] desktop:mt-[18px] tablet:text-headline-large text-title-large font-semibold font-inter break-keep ${inView ? 'animate-fadeSlideUp delay-1000' : ''}`}>
                        아나톨레 어학원이 여러분의 <br className="tablet:hidden desktop:block" />영어학습 여정에 함께합니다.
                    </div>

                    <div className="mt-[24px] desktop:mt-[28px] z-[2] desktop:w-[130px] w-[100px]">
                        <Link to="/inquiry">
                            <img src={HomeInquiryButton} alt="Home Inquiry Button" className={`${inView ? 'animate-heartBeat' : ''}`} />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerSection;
